export default __webpack_public_path__ + "static/media/laconic_mobile@2x.5064a038.jpg";